<template>
  <div class="animated fadeIn list-of-ap">
    <b-card>
      <div slot="header">Settlement of DP/Prepaid AP Invoice 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm" >Delete</b-button>
          <b-dropdown text="Posting" variant="primary mr-1" >
            <b-dropdown-item @click="posting" :disabled="(model.posting == 1 || selected.length>0)">Posting 1</b-dropdown-item>
            <b-dropdown-item @click="postingmulti" :disabled="(selected.length==0)">Posting Selected ({{selected.length}}) </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="posting" :disabled="(model.posting != 1 || selected.length>0)">Un Posting 1</b-dropdown-item>
            <b-dropdown-item @click="unpostingmulti" :disabled="(selected.length==0)">Unposting Selected ({{selected.length}}) </b-dropdown-item>
          </b-dropdown>
          <b-dropdown text="Print" variant="primary mr-1" >
            <b-dropdown-item @click="printjv" :disabled="(model.posting == 0)">Jurnal Voucher</b-dropdown-item>
            <b-dropdown-item @click="printjvmultiple" :disabled="(selected.length==0)">Jurnal Voucher Selected ({{selected.length}}) </b-dropdown-item>
          </b-dropdown>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter" >
        <b-col lg="5">
            <b-input-group >
              <b-input-group-prepend><label>Settlement Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Description </label></b-input-group-prepend>
              <b-form-input v-model="tblData.uraian" placeholder="Description" style="width:43% !important;"></b-form-input>
                <b-input-group-prepend><span class="pt-2">&nbsp;Posting&nbsp;</span></b-input-group-prepend>
                  <b-form-select v-model="tblData.posting" :plain="true" :options="dataList.postingStatus"></b-form-select>
            </b-input-group>
        </b-col>
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><label>AP Number</label></b-input-group-prepend>
              <b-form-input v-model="tblData.nomor" placeholder=" % for wildcard"></b-form-input>
                <b-input-group-prepend><span class="pt-2">&nbsp;Posting Group &nbsp;</span></b-input-group-prepend>
                <b-form-select v-model="tblData.postgroup" :plain="true" :options="postGroups"></b-form-select>
                <b-input-group-prepend><span class="pt-2">&nbsp;PO #</span></b-input-group-prepend>
                <b-form-input v-model="tblData.po" placeholder="Purch. Order#"></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
              <b-form-input v-model="tblData.vendor" placeholder="Vendor/Supplier"></b-form-input>
              <b-input-group-prepend><span class="pt-2">Invoice# &nbsp;</span></b-input-group-prepend>
              <b-form-input v-model="tblData.invoice" placeholder="Request Number"></b-form-input>
                  <b-input-group-append>
                        <b-button variant="success" size="sm" @click="refresh()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                  </b-input-group-append>
                  <b-input-group-append>
                        <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                  </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
        <template v-slot:thead-top="data">
          <b-tr>
            <b-th colspan="4"><span class="sr-only">Name and ID</span></b-th>
            <b-th variant="secondary" colspan="5" class="text-center">DP/PREPAID AP-INVOICE</b-th>
            <b-th variant="dark" colspan="5">AP FULL (PELUNASAN)</b-th>
          </b-tr>
        </template>

        <template v-slot:cell(selected)="data">
             <input
            name="selectjurnal"
            type="checkbox"
            @change="checkedjurnal($event,data.item)"
            :data-idrowunik="data.item.idrowunik"
            :checked="ischeckedjurnal(data.item.idrowunik)"
          />
        </template>
        <!-- A custom formatted header cell for field 'name' -->
        <template v-slot:head(selected)="data">
                  <a href="javascript:void(0)" class="text-danger" @click="checkedclear()">
                    <i class="fa fa-eraser"></i>
                  </a>
        </template>        
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#" :disabled="(data.item.posting==1)" style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" :disabled="(data.item.posting==1)" style="padding:0 !important;">Posting</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" :disabled="(data.item.posting==0)" style="padding:0 !important;">Un Posting</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" :disabled="(data.item.posting==0)" style="padding:0 !important;">Print JV</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#" :disabled="(data.item.posting==1)" style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>          
        <template v-slot:cell(nomor)="data">
          <div v-if="data.item.posting==0" style="background-color:yellow;">{{data.item.nomor}}</div>
          <div v-else>{{data.item.nomor}}</div>
        </template>

        <template v-slot:cell(tglsettl)="data">
          {{ data.item.tglsettl | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(tanggaldp)="data">
          {{ data.item.tanggaldp | moment("DD MMM YYYY") }}
        </template>
        <!-- <template v-slot:cell(totalinvxppndp)="data">
          {{data.item.matauangdp}} &nbsp; {{data.item.totalinvxppndp | numFormat}}
        </template> -->
        <template v-slot:cell(nilai)="data">
          <div v-if="data.item.posting==0" style="background-color:yellow;">           
            {{(data.item.nilai)|numFormat}}
          </div>
          <div v-else> 
            {{(data.item.nilai)|numFormat}}
          </div>
        </template>

        <template v-slot:cell(totalinv)="data">
          {{data.item.matauang}} &nbsp; {{data.item.totalinv | numFormat}}
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
            <b-input-group >
                <b-input-group-prepend><span  class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                <b-form-select :options="[10, 15, 20, 25, 30, 35, 40, 45, 50]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-input-group>
        </b-col>        
        <b-col cols="6">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure about doing this?</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
    <b-modal v-model="showReport" scrollable size="xl" title="Preview as PDF" hide-footer>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        <b-row class="justify-content-center mt-1">
            <b-button variant="primary" v-if="(isprintjv==true)" @click.stop="editjv">Edit Journal</b-button>
            <b-button variant="secondary" class="ml-2" @click="showReport=false" > Close</b-button>
        </b-row>
    </b-modal>
        <b-modal v-model="dpConfirm" size="lg" title="Settlement DP/Prepaid AP-Invoice" 
            :centered="true"  header-bg-variant="primary" :hide-footer="true" :no-close-on-esc="true" :no-close-on-backdrop="true" :hide-header-close="true">
            <b-row>
                <b-col lg="6">            
                  <b-input-group >
                    <b-input-group-prepend><label>Settlement Date</label></b-input-group-prepend>
                    <b-form-input v-model="apDpObj.tglsettl" type="date"  :state="!$v.apDpObj.tglsettl.$error"></b-form-input>                                        
                  </b-input-group>
                </b-col>   
                <b-col lg="6">
                    <b-input-group >
                        <b-input-group-prepend><label>Settlement Number</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomorsettl" readonly></b-form-input>
                    </b-input-group>
                </b-col>   
            </b-row>            
          <b-input-group >
              <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input  v-model="apDpObj.uraiansettl" :state="!$v.apDpObj.uraiansettl.$error"></b-form-input>
          </b-input-group>

            <b-input-group >
                <b-input-group-prepend><label>AP Number</label></b-input-group-prepend>
                <b-form-input readonly v-model="apDpObj.nomor" @keyup.13.native="lkuApinvShow=true" :state="!$v.apDpObj.apinvkey.$error"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuApinvShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
                        <b-input-group-prepend><span class="input-group-text">Invoice#</span></b-input-group-prepend>
                <b-form-input readonly v-model="apDpObj.invoice" ></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
                <b-form-input v-model="apDpObj.vendorinfo" disabled></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>AP Description</label></b-input-group-prepend>
                <b-form-input v-model="apDpObj.uraian" disabled></b-form-input>
            </b-input-group>
            <b-row no-gutters>
                <b-col lg="6">
                    <b-input-group >
                        <b-input-group-prepend><label>Purchase Order#</label></b-input-group-prepend>
                        <b-form-input v-model="apDpObj.po" disabled></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col lg="6">
                    <b-input-group >
                        <b-input-group-prepend ><label>&nbsp; &nbsp;Contract #</label></b-input-group-prepend>
                        <b-form-input v-model="apDpObj.kontrak" disabled></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-row no-gutters>
                <b-col lg="6">
                    <b-input-group >
                        <b-input-group-prepend><label>Total Invoice</label></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{apDpObj.matauang}}</span></b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="apDpObj.totalinv" :precision="2" disabled></my-number>
                    </b-input-group>
                </b-col>
                <b-col lg="6">
                    <b-input-group >
                        <b-input-group-prepend ><label>&nbsp; &nbsp;Outstanding</label></b-input-group-prepend>
                        <b-input-group-prepend ><span class="input-group-text" style="width:60px;">{{apDpObj.matauang}}</span></b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="apDpObj.outstand" :precision="2" disabled></my-number>
                    </b-input-group>
                </b-col>
            </b-row>

            <div class="report-wraper">
                    <table style="width: 100%;" class="">
                        <thead>
                            <tr>
                            <th width="30px"></th>
                            <th style="text-align:center" width="100px">Settled Amount</th>
                            <th style="text-align:center" width="100px">AP Number</th>
                            <th style="text-align:center" width="100px">Invoice No.</th>
                            <th style="text-align:center" width="100px">PO Number</th>
                            <th>Description</th>
                            <th style="text-align:center" width="30px">Rp,$,¥</th>
                            <th style="text-align:center" width="120px">Invoice Total (Excl.VAT)</th>
                            <th style="text-align:center" width="100px">UnSettled Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in apDownpay" :key="row.notgl" >
                                <td width="30px">    
                                    <b-form-checkbox v-model="row.selected" :value="1" :unchecked-value="0"/>
                                </td>
                                <td style="margin:0;padding:0;"><div style="width: 120px; overflow: hidden; display: inline-block; white-space: nowrap;">
                                    <my-number v-model="row.nilai"  class="form-control text-right"  style="border:none;font-size: 0.8rem !important;" :precision="2" ></my-number></div>
                                </td>
                                <td class="disabled">{{row.nomor}}</td>
                                <td class="disabled">{{row.invoice}}</td>
                                <td class="disabled">{{row.po}}</td>
                                <td class="disabled">{{row.uraian}}</td>
                                <td class="disabled" width="30px">{{row.matauang}}</td>
                                <td class="disabled" style="text-align:right">{{row.totalinvxppn | numFormat('0,0.00')}}</td>
                                <td class="disabled" style="text-align:right">{{row.SisaDP | numFormat('0,0.00')}}</td>
                            </tr>
                        </tbody>
                    </table>
            </div>                  
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="success" class="ml-1" @click="onSelectApDownpay" > <i class="fa fa-check-circle-o"></i> OK/Save</b-button>
                  <b-button variant="danger" class="ml-1" @click="onCancelApDownpay" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
        </b-modal>        
        <b-modal v-model="lkuApinvShow" size="lg" :hide-footer="true" title="Please select AP Invoice"  :centered="true">
            <lku-ap @click="onSelectLkuAp" :tagihandp="0" :outstand="1"></lku-ap>
        </b-modal>      

  </div>
</template>

<style lang="scss">
  .list-of-ap {
      table {
        // td:nth-child(1) {
        //   width: auto;
        // }
        // td:nth-child(2) {
        //   width: auto;
        // }
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }

}
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import myNumber from "../../components/my-number";
import lkuAp from "../lookup/lkuAp";
import apdpsttl from "../../apis/apdpsettle";
import dropdown from "../../data/dropdown";
import { validationMixin } from "vuelidate";
import { required, minValue, numeric } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { Loading, myNumber, lkuAp},
  mixins: [validationMixin],
  validations: {
        apDpObj :{
            apinvkey: { required },
            tglsettl: { required },
            uraiansettl: { required }
        },
  }, 
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      lkuApinvShow:false,
      lkuApinvData:{},
      isLoading:false,
      showReport:false,
      isprintjv:false,
      reportUrl: null,
        items: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,
        sortBy: 'tglsettl',
        sortDesc: true,
        DimCol:'Dim1'
      },
      model:{},deleted:{},
      postGroups:[],selected:[],
      receivingStatus:[{ value: '1', text: 'Received'},{ value: '0', text: 'Not Received'},{ value: '', text: '--- ALL ---'}],
      dataList: {
        YesNoAll: dropdown.ostandStatus,
        postingStatus: dropdown.postingStatus
      },
      saveClick:false,
      apDpObj:{apinvkey:''},
      apDpSttl: {
          items: [],
          selected:{},
          page: 1,
          limit: 15,
          total: 0,
      },
      apDownpay:[],
      dpConfirm:false,
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "selected",
            label: "",
            thStyle: "width:10px",
            thClass:"text-center",
            tdClass:"text-center",
          },
          {
            key: "action",
            label: "",
            thStyle: "width:20px",
            thClass: "text-center",
          },
          // {
          //   key: "nomorsettl",
          //   thStyle: "width:100px",
          //   label: "Settle Number",
          //   sortable: true
          // },
          {
            key: "tglsettl",
            thStyle: "width:100px",
            label: "Settle Date",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            sortable: true
          },
          {
            key: "invoicedp",
            label: "DP Invoice#",
            variant:"secondary" ,
            sortable: true
          },
          {
            key: "nomordp",
            label: "AP Number",
            sortable: true
          },
          {
            key: "tanggaldp",
            thStyle: "width:100px",
            label: "DP Date",
            sortable: true
          },
          {
            key: "uraiandp",
            label: "DP Description",
            sortable: true
          },
          // {
          //   key: "totalinvxppndp",
          //   label: "Total DP (Excl.VAT)",
          //   thStyle: "width:110px",
          //   tdClass: "text-right",
          //   sortable: true
          // },
          {
            key: "nilai",
            label: "Settled Amt.",
            thStyle: "width:110px",
            variant:"secondary" ,
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "nomor",
            label: "AP Number",
            sortable: true
          },
          {
            key: "invoice",
            label: "Invoice #",
            sortable: true
          },
          {
            key: "po",
            label: "PO/SO #",
            sortable: true
          },
          {
            key: "totalinv",
            label: "Total Invoice",
            thStyle: "width:110px",
            tdClass: "text-right",
            sortable: true
          },
        ];
        // const dims = this.$store.state.dimension;
        // for (let i = 0; i < dims.length; i += 1) {
        //   fields.push(          {
        //     key: `${dims[i].value}Txt`,
        //     thStyle: "width:100px",
        //     label: dims[i].text,
        //     sortable: true
        //   },)
        // }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  created: async function(){
      const accList = await apdpsttl.postgroup();
      this.postGroups = accList.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
        // const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // this.tblData.tgl1=this.$store.state.user.tglaktif;
        // this.tblData.tgl2=tgl2.format('YYYY-MM-DD');
  },  
  // sockets: {
  //       apinvtrx: function (data) {
  //           console.log('IO: apinvtrx ',data.source);
  //           if (data.compcode === this.$store.state.user.compcode) {
  //             this.refresh();
  //           }        
  //       },
  //       apinvdeleted: function (data) {
  //           console.log('fired by server. io.emit("apinvdeleted", data)',data);
  //           if (data.compcode === this.$store.state.user.compcode) {
  //             this.refresh();
  //           }        
  //       },
  //   },    

  methods: {
    onSelectLkuAp(_selected) {
        this.lkuApinvShow=false;
        this.apDpObj.apinvkey=_selected.apinvkey;
        this.apDpObj.nomor=_selected.nomor;
        this.apDpObj.invoice=_selected.invoice;
        this.apDpObj.uraian=_selected.uraian;
        this.apDpObj.vendor=_selected.vendor;
        this.apDpObj.vendorinfo=_selected.vendorinfo;
        this.apDpObj.vendor_id=_selected.vendor_id;
        this.apDpObj.po =_selected.po;       
        this.apDpObj.kontrak =_selected.kontrak;       
        this.apDpObj.matauang=_selected.matauang;
        this.apDpObj.totalinv=_selected.totalinv;
        // apDpObj.totalap
        this.apDpObj.outstand=_selected.outstand;        
        this.showApDownpay();
    },
    async showApDownpay(model) {
        try {
          if (model) {
                const [sttldtl,data] = await Promise.all([apdpsttl.detail(model), apdpsttl.getUangmuka({ vendor_id: this.apDpObj.vendor_id, po: this.apDpObj.po, apinvkey: this.model.apinvkeydp })]) ;
               this.apDownpay = data;
               this.apDpSttl.items=sttldtl;
          } else {
            const data = await apdpsttl.getUangmuka({ vendor_id: this.apDpObj.vendor_id, po: this.apDpObj.po }) ;
            this.apDownpay = data;
          }
            let ApDpIdx;
            this.apDownpay.forEach((dp,idx)=>{
                dp.selected=0;
                if (dp.po===this.model.po){
                    dp.selected=1;
                } else {
                    ApDpIdx = this.apDpSttl.items.findIndex(d => d.notgl==dp.apinvkey)
                    if (ApDpIdx>-1){
                        dp.selected=1;
                        dp.nilai=this.apDpSttl.items[ApDpIdx].nilai;
                    }
                }
            });
            this.dpConfirm=true;
        } catch (error) {
            console.log(error);
            // this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },
    onCancelApDownpay() {
        this.dpConfirm=false;
        this.saveClick=false;
    },
    async onSelectApDownpay() {
            const totaldp= this.apDownpay.reduce((a, b) => {
                            if (b.selected==1) a += b.nilai;
                            return a; 
                        }, 0);
            if ((this.apDpObj.outstand || 0) < totaldp) {
                toastr.error('Nilai Uang Muka yang di alokasikan melebihi total invoice Outstanding','ERROR MESSAGE',10000);
                return;
            } 
        // // pindahkan ke apDpSttl 
        // // yg terselect dan nilainya tidak Nol aja
        // let ApDpIdx;
        // dpTerpilih.forEach((dp,idx)=>{
        //     dp.notgl=dp.apinvkey;
        //     dp.apinvkey=this.model.apinvkey || '';
        //     dp.idrowunik='';
        //     ApDpIdx = this.apDpSttl.items.findIndex(d => d.notgl==dp.apinvkey)
        //     if (ApDpIdx>-1){
        //         dp.idrowunik=this.apDpSttl.items[ApDpIdx].idrowunik;
        //     }
        // });
        // this.apDpSttl.items=dpTerpilih;

        // this.save();
        try {
          this.isLoading=true;
          const dpTerpilih = this.apDownpay.filter(dp => ((dp.selected==1) && (dp.nilai != 0)));
          const row = {};
          for (var key in this.apDpObj) {
              row[key] = this.apDpObj[key];
          }
          row.tglsettl = moment(row.tglsettl).format('YYYY-MM-DD');
          row.lines=dpTerpilih;

          const hasil= await apdpsttl.save(row);
          this.isLoading=false;
          this.dpConfirm=false;
          this.tblData.tgl1=row.tglsettl;
          this.tblData.tgl2=row.tglsettl;
          this.refresh();
          // toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save AP",10000);          
          toastr.success(`Successfully`, "Save Settlement DP",10000);          
        } catch (error) {
          this.isLoading=false;
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }   
          
        }

    },
    ischeckedjurnal(val){
      const findjv = this.selected.find(x => x === val);
      if(findjv){
        return 'checked'
      }else{
        return '';
      }
    },
    checkedclear() {
      this.selected = [];
      // uncheck setelah posting selected
      const checkBoxes = document.querySelectorAll('[name="selectjurnal"]') || [];
      checkBoxes.forEach(element => {
        element.checked= false;
      });
      // $('[name="selectjurnal"]').each(function() {
      //     $(this).prop("checked", false);
      //   });
    },
    checkedjurnal(item,record) {
      this.rowClicked(record);
      const idrowunik = item.target.attributes["data-idrowunik"].value;
      if (item.target.checked) {
        const findjv = this.selected.find(x => x === idrowunik);
        if (!(findjv)){
          this.selected.push(idrowunik);
        }
      } else {
        const findIdx = this.selected.findIndex(x => x === idrowunik);
        this.selected.splice(findIdx, 1);
      }
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.apdplist) {
            this.tblData[key] = filter.apdplist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.apdplist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.apdplist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.isLoading=true;
      const list = await apdpsttl.list(this.tblData);      
      this.items = list;
      this.isLoading=false;

      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.vendor= '';
        this.tblData.po=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.invoice=  '';
        this.tblData.postgroup=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    saveFilter() {
      const keys = ['uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'invoice', 'vendor', 'vendorcode', 'po', 'postgroup', 'posting'];
      let filtered = false;
      const apdplist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              apdplist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          apdplist.page=this.tblData.page;
          apdplist.limit=this.tblData.limit;
          apdplist.sortBy=this.tblData.sortBy;
          apdplist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.apdplist=apdplist;
          this.$store.commit("filter", filter);
      }
    },    
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
        this.posting();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.printjv();        
    },
    rowPrintpb(record) {
      this.rowClicked(record);
        this.printpb();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();

    },    
    add(){
      // this.saveFilter();
        this.lkuApinvShow=true;
    },
    edit: function() {
        if (this.model.idrowunik) {
          if (this.model.nomorsettl) {
            // this.saveFilter();
            // router.push({name :'payable.apdpsettlefrm', params: { idrowunik: this.model.idrowunik}});
            const _selected= this.model;
            this.apDpObj.idrowunik=_selected.idrowunik;
            this.apDpObj.tglsettl=(_selected.tglsettl) ? moment(_selected.tglsettl).format('YYYY-MM-DD') : '';
            this.apDpObj.uraiansettl=_selected.uraiansettl;
            this.apDpObj.apinvkey=_selected.apinvkey;
            this.apDpObj.nomor=_selected.nomor;
            this.apDpObj.invoice=_selected.invoice;
            this.apDpObj.uraian=_selected.uraian;
            this.apDpObj.vendor=_selected.vendor;
            this.apDpObj.vendorinfo=_selected.vendorinfo;
            this.apDpObj.vendor_id=_selected.vendor_id;
            this.apDpObj.po =_selected.po;       
            this.apDpObj.kontrak =_selected.kontrak;       
            this.apDpObj.matauang=_selected.matauang;
            this.apDpObj.totalinv=_selected.totalinv;
            this.apDpObj.outstand=_selected.outstand;
            this.showApDownpay(this.model);            
          } else {
            toastr.error('AP DP ini jadi satu dengan AP pelunasan, tdk bisa di Edit secara terpisah','ERROR MESSAGE',10000);
          }
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    editjv: function() {
        if (this.model.idrowunik) {
            this.saveFilter();
            const tglsettl = moment(this.model.tglsettl).format('YYYY-MM-DD');
            router.push({name :'payable.editjvfrm', params: { nomor: this.model.nomor, tglsettl, kodejurnal:'APINV', fsubkode2:'ap_invoice_tt',kodefield2:'idrowunik',subkode2: this.model.idrowunik}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.idrowunik) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await apdpsttl.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.idrowunik==this.model.idrowunik));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },

    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    posting: async function () {
        if (this.model.idrowunik) {
            if ((this.model.posting || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.model.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingmulti: async function() {
      this.isLoading = true;
      try {
        if (this.selected.length > 0) {
          await apdpsttl.postingmulti(this.selected);
          this.printjvmultiple();
          this.refresh();
          this.isLoading = false;
        } else {
          this.isLoading = false;
          toastr.warn("Please select row(s) that want to be Posting!");
        }
      } catch (error) {
        this.isLoading = false;
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    unpostingmulti: async function() {
      this.isLoading = true;
      try {
        if (this.selected.length > 0) {
          await apdpsttl.unpostingmulti(this.selected);
          this.selected = [];
          this.refresh();
          this.isLoading = false;
        } else {
          this.isLoading = false;
          toastr.warn("Please select row(s) that want to be Posting!");
        }
      } catch (error) {
        this.isLoading = false;
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    postingData: async function(){
        this.isLoading=true;
        try {
            await apdpsttl.posting(this.model);
            this.model.posting=1;
            this.printjv();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  

    unpostData: async function(){
        this.isLoading=true;
        try {
            await apdpsttl.postingUndo(this.model);
            this.model.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printjv: async function()
    {
      if (this.model.idrowunik) {
          try {
              if (this.model.nomorsettl) {
                  this.reportUrl= await apdpsttl.printjv(this.model);
                  this.isprintjv=true;
                  this.showReport=true;
              } else {
                  this.showReport=true;
                  this.reportUrl= await apdpsttl.printjvap(this.model);
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printjvmultiple: async function()
    {
      if (this.selected) {
          try {
                this.showReport=true;
              this.isprintjv=false;
              this.reportUrl= await apdpsttl.printjvmultiple(this.selected);
              this.selected = [];
          } catch (error) {
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select row(s) that want to be Printed!');
        }
    },
    printpb: async function()
    {
      if (this.model.idrowunik) {
          try {
                this.showReport=true;
              this.isprintjv=false;
              this.reportUrl= await apdpsttl.printpb(this.model);
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printpbselected: async function()
    {
      if (this.selected) {
          try {
                this.showReport=true;
              this.isprintjv=false;
              this.reportUrl= await apdpsttl.printpbmultiple(this.selected);
          } catch (error) {
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select row(s) that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await apdpsttl.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/payable/home");
    },    
  }
};
</script>
